/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Interior_MaterialInputs */

const en_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interior Material`)
};

const es_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material interior`)
};

const fr_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matière intérieure`)
};

const de_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innenmaterial`)
};

const ja_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内装素材`)
};

const zh_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内饰材质`)
};

const ar_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مادة الداخلية`)
};

const id_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material Interior`)
};

const it_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale Interni`)
};

const ru_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Материал салона`)
};

const pt_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material Interno`)
};

const ko_field_interior_material = /** @type {(inputs: Field_Interior_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내부 소재`)
};

/**
* | output |
* | --- |
* | "Interior Material" |
*
* @param {Field_Interior_MaterialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_interior_material = /** @type {((inputs?: Field_Interior_MaterialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Interior_MaterialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_interior_material(inputs)
	if (locale === "es") return es_field_interior_material(inputs)
	if (locale === "fr") return fr_field_interior_material(inputs)
	if (locale === "de") return de_field_interior_material(inputs)
	if (locale === "ja") return ja_field_interior_material(inputs)
	if (locale === "zh") return zh_field_interior_material(inputs)
	if (locale === "ar") return ar_field_interior_material(inputs)
	if (locale === "id") return id_field_interior_material(inputs)
	if (locale === "it") return it_field_interior_material(inputs)
	if (locale === "ru") return ru_field_interior_material(inputs)
	if (locale === "pt") return pt_field_interior_material(inputs)
	return ko_field_interior_material(inputs)
});